import { controllerModel } from 'shared';

import { AI_CHAT_BOTTOM_SHEET } from '../config';

export const useAiChatBottomSheet = () => {
  const bottomSheet = controllerModel.useBottomSheet();

  const showBottomSheet = () => {
    bottomSheet.show(AI_CHAT_BOTTOM_SHEET);
  };

  const hideBottomSheet = () => {
    bottomSheet.hide(AI_CHAT_BOTTOM_SHEET);
  };

  return {
    showBottomSheet,
    hideBottomSheet,
  };
};
